<div class="row">
    <div class="offset-sm-2 col-sm-8 col-16">
        <div class="mb-5">
            <div
                class="adelle-sans-31 sans font-weight-400 dark-gray mb-3"
                style="padding-top: 5vw"
            >
                Lernkontrolle

                <span *ngIf="(courseType$ | async) === 'EDUCATION_COURSE'"
                    >MODUL
                    {{
                        (selectModuleId$ | async)?.sequentialNumber
                            | numberToNumbering: 'upperRomanNumerals'
                    }}</span
                >

                <span *ngIf="(courseType$ | async) === 'TRAINING_COURSE'">
                    Weiterbildung
                </span>
            </div>
            <div *ngIf="(controlTestResult$ | async) === undefined">
                <p class="adelle-sans-17 font-weight-300 dark-gray">
                    Insgesamt gibt es
                    {{ (this.controlTest$ | async)?.controlQuestions?.length }}
                    Fragen. Bitte kreuzen Sie jeweils die richtige Antwort an.
                    Pro Frage gibt es nur eine richtige Möglichkeit. <br />
                    Die Lernkontrolle kann beliebig of wiederholt werden. <br />
                    Eine bestandene Lernkontrolle kann nicht wiederholt werden.
                </p>
            </div>
            <div *ngIf="(controlTestResult$ | async) !== undefined">
                <div class="mt-3">
                    <!-- Test ist nicht Weiterbildung und Test bestanden -->
                    <div
                        *ngIf="
                            (controlTestResult$ | async) &&
                            (courseType$ | async) === 'TRAINING_COURSE'
                        "
                    >
                        <div class="d-flex flex-row pt-2">
                            <div>
                                <img
                                    src="assets/bestanden.svg"
                                    alt="yes_green"
                                    style="width: 27px; height: 29px"
                                />
                            </div>
                            <div class="pl-2">
                                <p
                                    class="adelle-pe-25 font-weight-400 green-color"
                                >
                                    Glückwunsch! Sie haben die Lernkontrolle in
                                    <br />
                                    diesem
                                    <span class="adelle-pe-25">Kurs</span>
                                    erfolgreich bestanden.
                                </p>
                                <p
                                    class="adelle-sans-17 font-weight-300 pt-4 dark-gray"
                                >
                                    Das Testergebnis können Sie in Ihrem
                                    <a
                                        [routerLink]="[
                                            '../../../../learnState'
                                        ]"
                                        class="dark-gray"
                                        style="
                                            text-decoration: underline #454f54;
                                        "
                                        >Lernstatus</a
                                    >
                                    downloaden.
                                </p>
                                <div class="pt-4">
                                    <cna-gradient-button
                                        notgradient="true"
                                        buttonTitle="Zurück zur Modulübersicht"
                                        buttonRouterLink="../../../courseOverview/"
                                    ></cna-gradient-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Test ist eine Weiterbildung und Test bestanden -->
                    <div
                        *ngIf="
                            (controlTestResult$ | async) &&
                            (courseType$ | async) === 'EDUCATION_COURSE'
                        "
                    >
                        <div class="d-flex flex-row pt-2">
                            <div>
                                <img
                                    src="assets/bestanden.svg"
                                    alt="yes_green"
                                    style="width: 27px; height: 29px"
                                />
                            </div>
                            <div class="pl-2">
                                <p
                                    class="adelle-pe-25 font-weight-400 green-color"
                                >
                                    Glückwunsch! Sie haben die Lernkontrolle in
                                    <br />
                                    diesem
                                    <span class="adelle-pe-25">MODUL</span>
                                    erfolgreich bestanden.
                                </p>
                                <p
                                    class="adelle-sans-17 font-weight-300 pt-4 dark-gray"
                                >
                                    Das Testergebnis können Sie in Ihrem
                                    <a
                                        [routerLink]="[
                                            '../../../../learnState'
                                        ]"
                                        class="dark-gray"
                                        style="
                                            text-decoration: underline #454f54;
                                        "
                                        >Lernstatus</a
                                    >
                                    downloaden.
                                </p>
                                <ng-container
                                    *ngIf="
                                        (selectModuleId$ | async)
                                            ?.sequentialNumber === 4
                                    "
                                >
                                    <p class="adelle-sans-17 font-weight-300 pt-1 dark-gray">
                                        Sie haben die erforderliche Stundenzahl im theoretischen Teil Ihrer
                                        Fachanwaltsausbildung vollständig erbracht.
                                    </p>
                                    <p class="adelle-sans-17 font-weight-600 dark-gray pt-2">
                                        Wie geht es nun weiter?
                                    </p>
                                    <ul class="adelle-sans-17 font-weight-300 pt-1 dark-gray">
                                        <li>Sie können entweder an einem unserer <span class="font-weight-400">regulären Prüfungstermine</span> teilnehmen oder</li>
                                        <li>einen <span class="font-weight-400">individuellen Prüfungstermin</span> bei Ihnen vor Ort vereinbaren.</li>
                                    </ul>
                                    <p class="adelle-sans-17 font-weight-300 pt-1 dark-gray">
                                        In beiden Fällen finden Sie sämtliche Informationen sowie die
                                        Anmeldemöglichkeit in Ihrem persönlichen Bereich unter:
                                        <a routerLink="../../../../exams">„Mein AK JURA“ → „Prüfung“</a>
                                    </p>
                                    <p class="adelle-sans-17 font-weight-600 dark-gray pt-2">
                                        Hinweise zur Prüfungsvorbereitung
                                    </p>
                                    <ul class="adelle-sans-17 font-weight-300 pt-1 dark-gray">
                                        <li>Jede der drei Klausuren umfasst etwa <span class="font-weight-400">25 Fragen</span>.</li>
                                        <li>Als Vorbereitung empfehlen wir die <span class="font-weight-400">Bearbeitung des Repetitoriums</span>. Die dort behandelten Inhalte entsprechen in Umfang und Reihenfolge den späteren Prüfungsfragen.</li>
                                        <li><span class="font-weight-400">Zugelassene Hilfsmittel</span>: alle Gesetzestexte. Markierungen und handschriftliche Notizen sind ausdrücklich gestattet.</li>
                                        <li>Gesetzestexte dürfen sowohl <span class="font-weight-400">in gedruckter Form</span> als auch <span class="font-weight-400">digital</span> (z. B. auf einem Tablet) verwendet werden.</li>
                                    </ul>
                                    <p class="adelle-sans-17 font-weight-600 dark-gray pt-2">
                                        Hinweise zur Prüfungsgebühr
                                    </p>
                                    <p class="adelle-sans-17 font-weight-300 pt-1 dark-gray">
                                        Die Rechnung für die Prüfungsgebühr erhalten Sie erst nach Ihrer tatsächlichen Teilnahme an der Prüfung.
                                    </p>
                                    <p class="adelle-sans-17 font-weight-300 pt-1 dark-gray pt-1">
                                        Bei Fragen stehen wir Ihnen jederzeit - gerne auch telefonisch - zur Verfügung.
                                    </p>
                                    <p class="adelle-sans-17 font-weight-300 pt-1 dark-gray pt-1">
                                        Ihr AK-JURA Team
                                    </p>
                                </ng-container>
                                <div class="pt-4">
                                    <cna-gradient-button
                                        notgradient="true"
                                        buttonTitle="Zurück zur Modulübersicht"
                                        buttonRouterLink="../../../courseOverview/"
                                    ></cna-gradient-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Test nicht bestanden -->
                    <div *ngIf="!(controlTestResult$ | async)">
                        <div class="d-flex flex-row pt-2">
                            <div>
                                <img
                                    src="assets/falsch.svg"
                                    alt="red-cross"
                                    style="width: 28px; height: 28px"
                                />
                            </div>
                            <div class="pl-2">
                                <p
                                    class="adelle-pe-25 font-weight-400 red-color"
                                >
                                    Sie haben die Lernkontrolle leider nicht
                                    bestanden. <br />
                                    Bitte wiederholen Sie die Lernkontrolle.
                                </p>
                                <p
                                    class="adelle-sans-17 font-weight-300 pt-4 dark-gray"
                                >
                                    Mit den Lernkontrollen überprüfen Sie
                                    eigenverantwortlich Ihren <br />
                                    aktuellen Wissensstand. Sie können die nicht
                                    bestandene <br />
                                    Lernkontrolle beliebig oft wiederholen.
                                </p>
                                <div style="padding-top: 29px">
                                    <cna-gradient-button
                                        notgradient="true"
                                        buttonTitle="Lernkontrolle wiederholen"
                                        (click)="retryTest()"
                                    ></cna-gradient-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="(controlTestResult$ | async) === undefined">
    <div *ngIf="(controlQuestions$ | async) !== undefined">
        <cna-test-form
            [controlQuestions]="controlQuestions$ | async"
        ></cna-test-form>
    </div>
</div>
